import React, { useState } from 'react';

import { GeneralModal, FormInput_text, CustomEmailInput } from "components";
import { func_validation } from 'functions';



function UpdateClientModal(props) {
    const {
        isModalVisible,
        updateModalVisibility,
        isEditing,
        selectedClient,

        addClient_requesting, addClient_status,
    } = props;

    let init_companyName = func_validation.getObjectPropertyValue(selectedClient, "companyName","");
    let init_companyEmail = func_validation.getObjectPropertyValue(selectedClient, "companyEmail","");
    let init_name = func_validation.getObjectPropertyValue(selectedClient, "name", "");

    const [companyName, setCompanyName] = useState(init_companyName);
    const [companyEmail, setCompanyEmail] = useState(init_companyEmail);
    const [isEmailValid, setIsEmailValid] = useState(true);
    const [name, setName] = useState(init_name);

    const [isSubmissionAttempeted, setIsSubmissionAttempeted] = useState(false);

    function handleOnSubmit() {
        setIsSubmissionAttempeted(true);

        if (func_validation.isStringTrimNotEmpty(companyName) &&
            func_validation.isStringTrimNotEmpty(companyEmail) &&
            func_validation.isStringTrimNotEmpty(name)) {
            
            let obj = {
                companyName,
                emailAddress: companyEmail,
                name
            };

            if (isEditing &&
                func_validation.isFunction(props.updateClient)) {

                props.updateClient(obj);
            }
            else if (func_validation.isFunction(props.addClient))
                props.addClient(obj);
        }
    }
 

    return (
        <GeneralModal
            modalWapperClassName={"distributorPortal-clientRegistration-updateClientModal"}
            isModalVisible={isModalVisible}

            title={isEditing? "Edit Client": "Register Client"}
            headerClassName={"distributorPortal-clientRegistration-updateClientModal-header"}
            
            updateParentState={updateModalVisibility}

            bodyWrapperClassName={"distributorPortal-clientRegistration-updateClientModal-content"}
            content={(
                <React.Fragment>
                    {/* Company Name */}
                    <FormInput_text
                        className={"distributorPortal-clientRegistration-updateClientModal-companyName"}
                        customInputClassName={"distributorPortal-clientRegistration-updateClientModal-companyName-input"}
                        inputValue={companyName}
                        propagateValueChange={(stateName, value) => { setCompanyName(value); }}

                        inputLabel={"Company Name"}

                        customErrorMsg={"Required"}
                        isFormSubmissionAttempted={isSubmissionAttempeted}

                        isMarginBtmOptional
                    />

                    {/* Company Email */}
                    <CustomEmailInput
                        className={"distributorPortal-clientRegistration-updateClientModal-companyEmail"}

                        label={"Company Email"}
                        options={{
                            isLabelOptional: false,
                            isInputOptional: false,
                            isMarginBtmOptional: true,
                        }}
                        email={companyEmail}
                        handleValueChange={setCompanyEmail}
                        isEmailValid={isEmailValid}
                        handleEmailValidity={setIsEmailValid}

                        isFormSubmissionAttempted={isSubmissionAttempeted}

                        handleOnEnterPressed={handleOnSubmit}
                    />

                    {/* Name */}
                    <FormInput_text
                        className={"distributorPortal-clientRegistration-updateClientModal-name"}
                        customInputClassName={"distributorPortal-clientRegistration-updateClientModal-name-input"}
                        inputValue={name}
                        propagateValueChange={(stateName, value) => { setName(value); }}

                        inputLabel={"Name"}

                        customErrorMsg={"Required"}
                        isFormSubmissionAttempted={isSubmissionAttempeted}

                        isMarginBtmOptional
                    />
                </React.Fragment>
            )}

            footerClassName={"distributorPortal-clientRegistration-updateClientModal-footer"}
            confirmButtonText={isEditing? "Update":"Register"}
            handleOnConfirm={handleOnSubmit}
            isConfirmSuccessful={addClient_status}
            confirmButtonProps={{
                isLoading: addClient_requesting
            }}
            isConfirmButtonVisible
        />
    );
}

export default UpdateClientModal;